import appConfig from '../../config';
import organisationHistory from '../utils/organisationHistory';

import {SELECT_ORGANISATION} from './constant';

export const setSelectedOrganisation = payload => ({
  type: SELECT_ORGANISATION,
  payload
});

export const selectOrganisation = organisation => dispatch => {
  // Permits to share context in mf mode
  if (appConfig.isMicrofront && organisation) {
    window.localStorage.setItem('state', JSON.stringify({ofaOrganisationId: organisation.organisationId}));
  }
  organisationHistory.push(organisation);
  return dispatch(setSelectedOrganisation({organisation}));
};
